export default "__VITE_ASSET__roTndqiz__"